function variantHelpPopup() 
{
    var infoIcons = document.querySelectorAll( ".product-variant-picker-block .info-icon" );

    infoIcons.forEach(( infoIcon ) => 
    {
        infoIcon.addEventListener("click", (event) => 
        {
            var infoIconAttr = infoIcon.getAttribute( "data-option_name" );
            var popupEl = document.querySelector( "[data-block_type='" + infoIconAttr + "']" );
            if ( popupEl != null ) 
            {
                document.body.style.overflow = "hidden";
                popupEl.closest( '.variant_help_popup' ).classList.remove( 'hidden' );
                popupEl.classList.remove( 'hidden' );
            }
        });
    });
}

function closevariantHelpPopup() 
{
    var closeButtons = document.querySelectorAll( ".variant_help_popup .close" );
    closeButtons.forEach(( closeButton ) => 
    {
        closeButton.addEventListener("click", (event) => 
        {
            document.body.style.overflow = "initial";
            closeButton.closest( '.variant_help_popup' ).classList.add( 'hidden' );
            closeButton.closest( '.variant_popup' ).classList.add( 'hidden' );
        });
    });
}

document.addEventListener( "DOMContentLoaded", (event) => 
{
    variantHelpPopup();
    closevariantHelpPopup();
});
